module.exports = __webpack_public_path__ + "static/media/rhino_picture_title_rounded.e0da32b9.png";